import Vue from "vue";
export const ChartEvents = new Vue();
